export const AGGREGATION_LOADING = "AGGREGATION_LOADING";
export const AGGREGATION_ERROR = "AGGREGATION_ERROR";
export const AGGREGATION_GET_USER = "AGGREGATION_GET_USER";



// WEBPACK FOOTER //
// ./src/actions/aggregation/constants.js